module.exports = __webpack_public_path__ + "static/media/15UN-Habitat2.9239e6b1.jpg";